import {
  AuthenticationResult,
  InteractionRequiredAuthError,
} from '@azure/msal-browser'

import { getEnvs } from '../utils/env'
import { msalInstance } from './config'

const { backendAppClientId } = getEnvs()

// Ask for the .default scope of the backend application, in order to trigger the combined consent flow. Since the login
// request didn't include this scope, when acquiring the jwt token for calling the backend application the user will
// be redirected to a page in which he will be asked for consent over the required scope (this happen only the first
// time when the user hasn't granted the consent yet).
const acquireBackendJwtRequest = {
  scopes: [`${backendAppClientId}/user_impersonation`],
  // Ensure the refresh token has at least 2h of validity
  refreshTokenExpirationOffsetSeconds: 7200,
  forceRefresh: true,
}

export async function acquireAccessToken(): Promise<void | AuthenticationResult> {
  return msalInstance
    .acquireTokenSilent(acquireBackendJwtRequest)
    .catch(async (error) => {
      if (error instanceof InteractionRequiredAuthError) {
        localStorage.clear()
        window.location.reload()
      } else {
        // eslint-disable-next-line no-console
        console.error('unexpected error on acquireTokenSilent request:', error)
      }
    })
}
